import Image from 'next/image'
import Link from 'next/link'
import DownloadAppleIcon from '../ui/icons/download-apple'
import DownloadGoogleIcon from '../ui/icons/download-google'
import { HomeContentBlock, HomeParagraph, HomeSection, HomeTitle } from './base'

const MobileShowcase = () => {
  return (
    <HomeSection padding='base' layout='grid'>
      <div className='order-2 lg:order-1 flex justify-center lg:justify-start'>
        <Image
          src='/images/home/mobile_img.webp'
          alt='Mobile Showcase'
          width={1000}
          height={1000}
          loading='lazy'
          className='w-full h-auto max-w-md lg:max-w-none'
        />
      </div>

      <div className='order-1 lg:order-2'>
        <HomeContentBlock>
          <div className='space-y-4'>
            <HomeTitle size='section'>Inform the media</HomeTitle>

            <HomeParagraph>
              Approve or deny which media members follow your content updates — giving approved journalists and outlets
              the visibility they need without overwhelming your internal teams!
            </HomeParagraph>
          </div>

          <div className='flex flex-col sm:flex-row gap-4'>
            <Link
              href='https://apps.apple.com/us/app/real-time-sports-content/id6480104774'
              target='_blank'
              className='relative w-[168px] h-[56px] hover:scale-105 transition-all duration-300'
            >
              <DownloadAppleIcon />
            </Link>
            <Link
              href='https://play.google.com/store/apps/details?id=live.rtsc.app'
              target='_blank'
              className='relative w-[189px] h-[56px] hover:scale-105 transition-all duration-300'
            >
              <DownloadGoogleIcon />
            </Link>
          </div>
        </HomeContentBlock>
      </div>
    </HomeSection>
  )
}

export default MobileShowcase
